var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.912 20.664c4.784-4.784 4.784-12.54 0-17.324a.75.75 0 011.06-1.06c5.37 5.37 5.37 14.075 0 19.445a.75.75 0 11-1.06-1.06z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.834 17.836a8.25 8.25 0 000-11.667.75.75 0 111.06-1.06c3.808 3.807 3.808 9.98 0 13.788a.75.75 0 01-1.06-1.06z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.755 15.008a4.25 4.25 0 000-6.01.75.75 0 111.06-1.061 5.75 5.75 0 010 8.131.75.75 0 01-1.06-1.06zM10.5 5.005a.75.75 0 00-1.28-.54L5.435 8.25H3.75A1.75 1.75 0 002 10v4c0 .966.784 1.75 1.75 1.75h1.694l3.73 3.731A.749.749 0 0010.5 19V5.005zM9 17.185V6.806L6.326 9.481a.748.748 0 01-.576.269h-2a.25.25 0 00-.25.25v4c0 .138.112.25.25.25h1.92a.748.748 0 01.61.216L9 17.186z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoise);
export default __webpack_public_path__ + "static/media/Noise.9282e5e0b0a2db05da2363129e25cc89.svg";
export { ForwardRef as ReactComponent };